import React ,{useEffect,useState}from "react";
import {Button, message, Form,Row,Col,Input} from "antd";
import {Link} from "react-router-dom";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import LoginPic from '../assets/images/AkodeRed.png'
import Screen from '../util/Extensions/Screens'
import { PlusOutlined} from '@ant-design/icons';
import "../routes/Akode/style.css"
import ReCAPTCHA from "react-google-recaptcha";
import ClientCaptcha from "react-client-captcha"

import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_TOKEN_SET
} from "../constants/ActionTypes";
import axios from 'util/Api'
import {notification,Modal} from 'antd'
import config from "util/ApiforContext"
import {useDispatch, useSelector} from "react-redux";
import {userSignIn} from "../appRedux/actions/Auth";
export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};
const FormItem = Form.Item;
const SignIn = (props) => {
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [smsValue, setSmsValue] = useState("");
  const [captchaCode, setCaptchaCode] = useState("");
  const [visible, setVisible] = useState(false);
  const [captchaKey, setCaptchaKey] = useState(0);

  const [expiration, setExpiration] = useState("");
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");
  const [tenantId, setTenantId] = useState("");
  const [tokenUser, setToken] = useState("");
  const [userName, setUserName] = useState("");
  const [smsPassword, setSmsPassword] = useState("");
  const {initialMinute = 0} = props;
  const [ minutes, setMinutes ] = useState(initialMinute);
  const [seconds, setSeconds ] =  useState(180);
  const [errorText, setErrorText ] =  useState("");
  const [recaptchaToken, setRecaptchaToken ] =  useState("");
  const [loginForEmail, setLoginForMail ] =  useState("");
  const [psr, setPsr ] =  useState("");
  const [isCaptchaRequired, setIsCaptchaRequired] = useState(false);

  const recaptchaRef = React.createRef();

  useEffect(()=>{
  let myInterval = setInterval(() => {
          if (seconds > 0) {
              setSeconds(seconds - 1);
          }
          if (seconds === 0) {
              if (minutes === 0) {
                handleCancel()
              } else {
                  setMinutes(minutes - 1);
                  setSeconds(59);
              }
          } 
      }, 1000)
      return ()=> {
          clearInterval(myInterval);
        };
  });
  const [form] = Form.useForm();
  const showModal = () => {
    setSeconds(180)
    setErrorText("")
    setVisible(true)
  }
  const setCode = captchaCode => {
    setCaptchaCode(captchaCode)
  }
  const handleSubmit = (values) => {
    if(values.Sms === undefined || values.Sms === ""){
      setErrorText("*Lütfen giriş yapınız.")
      setLoadingBtn(false)
      setCaptchaKey(captchaKey + 1)
    }else{
      axios.post(`${config.apiUrl}/Auth/Login`, 
      {
          email: loginForEmail,
          password: psr,
          ScreenOption: Screen.screen,
          SmsPsr: values.Sms
      }
      ).then(({data}) => {
        const expiration = new Date(data.data.expiration).getTime();
        setExpiration(expiration)
        setUserId(data.data.userId)
        setEmail(data.data.email)
        setTenantId(data.data.tenantId)
        setToken(data.data.token)
        setUserName(data.data.userName)
        if (data.success) {
            setLoadingBtn(true)
            openNotificationWithIcon("success")
            window.location.reload()
            localStorage.setItem("userId", JSON.stringify(data.data.userId));
            localStorage.setItem("email", JSON.stringify(data.data.email));
            localStorage.setItem("tenantId", JSON.stringify(data.data.tenantId));
            localStorage.setItem("expiration", JSON.stringify(expiration));
            localStorage.setItem("token", JSON.stringify(data.data.token));
            localStorage.setItem("userName", JSON.stringify(data.data.userName));
            axios.defaults.headers.common['Authorization'] = "Bearer " + data.data.token;
        } else {
          setCaptchaKey(captchaKey + 1)
          dispatch({type: FETCH_ERROR, payload: data.message});
        }
      }).catch(function (error) {
        if(error.response.status === 406){
          setCaptchaKey(captchaKey + 1)
          error.response.data.data.map((item)=>{
            errorList.push(item);
          })
          errorListNotification('error')
            setLoadingBtn(false)
            setLoading(false)
            window.grecaptcha.reset();
            setRecaptchaToken("");

         }else{
          setCaptchaKey(captchaKey + 1)
          sameError('error')
            setLoadingBtn(false)
            setLoading(false)
            window.grecaptcha.reset();
            setRecaptchaToken("");

         }
      });
      setSmsValue(values.Sms)
    }
  }
  const handleCancel = () => {
    if(handleCancel){
      setLoading(false)
    }
    setVisible(false)
    setLoadingBtn(false)
  };
  const sameError = type => {
    notification[type]({
      message: 'Hata',
      description:
        'Bir hata oluştu.',
        duration: 2,
    });
  };
  const loginError = type => {
    notification[type]({
      message: 'Hata',
      description:
        'Kullanıcı adı veya şifre hatalı.',
        duration: 2,
    });
  };
  const captchaError = type => {
    notification[type]({
      message: 'Hata',
      description:
        'Girilen kod hatalı, tekrar deneyiniz.',
        duration: 5,
    });
  };
  const errorList = [];
  const errorListNotification = type => {
    errorList.map((item)=> {
      notification[type]({
        message: 'Hata',
        description:
        item
         ,
          duration: 3,
      });
    })
  };
  function onSubmits() {
    const recaptchaValue = recaptchaRef.current.getValue();
    props.onSubmit(recaptchaValue);
  }
  const dispatch = useDispatch();
  const token = useSelector(({auth}) => auth.token);
  const onFinishFailed = errorInfo => {
    setLoading(false)
  };
  const success = () => {
    const hide = message.loading('Giriş yapılıyor..', 0);
    setTimeout(hide, 5000);
    setCaptchaKey(captchaKey + 1)
  };
  const onFinish = values => {
    // CAPTCHA her zaman zorunlu
    if (!recaptchaToken) {
      notification.error({
        message: 'CAPTCHA Gerekli',
        description: 'Güvenlik nedeniyle CAPTCHA doğrulaması gereklidir. Lütfen CAPTCHA\'yı tamamlayın.',
        duration: 3,
      });
      setLoading(false);
      setLoadingBtn(false);
      return;
    }

    setLoginForMail(values.email);
    setPsr(values.password);
    axios.post(`${config.apiUrl}/Auth/PsrControl`,{
      email: values.email
    }).then(({data}) => {
      if(data === null || data === ""){
        axios.post(`${config.apiUrl}/Auth/Login`, 
        {
            email: values.email,
            password: values.password,
            ScreenOption: Screen.screen,
            RecaptchaToken: recaptchaToken || null
        }
        ).then(({data}) => {
          if(data){
            showModal();
          }else{
            loginError();
          }
        }).catch(function (error) {
          // Başarısız deneme - CAPTCHA'yı zorunlu yap ve kontrol et
          setIsCaptchaRequired(true);
          checkCaptchaRequirement();
          
          // Error handling - error.response undefined olabilir (network hatası, CORS vb.)
          if(error && error.response && error.response.status === 406){
            setCaptchaKey(captchaKey + 1)
            if(error.response.data && error.response.data.data){
              error.response.data.data.map((item)=>{
                errorList.push(item);
              })
              errorListNotification('error')
            }
            setLoading(false)
            setLoadingBtn(false)
            window.grecaptcha.reset();
            setRecaptchaToken("");
           }else if(error && error.response){
            setCaptchaKey(captchaKey + 1)
            sameError('error')
            setLoading(false)
            setLoadingBtn(false)
            window.grecaptcha.reset();
            setRecaptchaToken("");
           }else{
            // Network hatası veya CORS sorunu
            notification.error({
              message: 'Bağlantı Hatası',
              description: 'Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin veya daha sonra tekrar deneyin.',
              duration: 5,
            });
            setLoading(false)
            setLoadingBtn(false)
            window.grecaptcha.reset();
            setRecaptchaToken("");
           }
        });
      }else{
        props.history.push(`/reset-password/${data}/true`)
      }
    }).catch(function (error) {
      // Error handling - error.response undefined olabilir (network hatası, CORS vb.)
      if(error && error.response && error.response.status === 406){
        setCaptchaKey(captchaKey + 1)
        if(error.response.data && error.response.data.data){
          error.response.data.data.map((item)=>{
            errorList.push(item);
          })
          errorListNotification('error')
        }
        setLoading(false)
        window.grecaptcha.reset();
        setRecaptchaToken("");
       }else if(error && error.response){
        setCaptchaKey(captchaKey + 1)
        sameError('error')
        setLoading(false)
        window.grecaptcha.reset();
        setRecaptchaToken("");
       }else{
        // Network hatası veya CORS sorunu
        notification.error({
          message: 'Bağlantı Hatası',
          description: 'Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin veya daha sonra tekrar deneyin.',
          duration: 5,
        });
        setLoading(false)
        window.grecaptcha.reset();
        setRecaptchaToken("");
       }
    });
    
   
  };
  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Giriş işlemi başarılı.',
        duration: 2,
    });
};
  useEffect(() => {
    if (token !== null) {
      props.history.push('/home');
    }
  }, [token, props.history]);

  // Sayfa yüklendiğinde CAPTCHA zorunluluğunu kontrol et
  useEffect(() => {
    checkCaptchaRequirement();
  }, []);

  const checkCaptchaRequirement = () => {
    axios.get(`${config.apiUrl}/Auth/IsCaptchaRequired`)
      .then(({data}) => {
        setIsCaptchaRequired(data.isCaptchaRequired || false);
      })
      .catch(() => {
        setIsCaptchaRequired(false);
      });
  };
  
  function onChange(value) {
    setRecaptchaToken(value);
  }

  return (
    <div className="gx-login-container">
      <div className="gx-login-content">
        <div className="gx-login-header gx-text-center">
          <h1 className="gx-login-title">
            <img src={LoginPic} alt='Neature' style={{marginBottom: '11%',width: '64%' }} />
          
          </h1>
        </div>

        <Form
          initialValues={{ remember: true }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0">
          <FormItem rules={[{ required: true, message: 'Email alanı zorunludur!' }]} name="email">

              <Input prefix={<UserOutlined style={{color: 'rgba(0,0,0,.25)'}}/>} 
              autoComplete="off"
                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                     placeholder="Email"/>
          </FormItem>
          <FormItem rules= {[{required: true, message: 'Şifre alanı zorunludur!'}]} style={{marginBottom:-2}} name="password">

              <Input prefix={<LockOutlined  style={{color: 'rgba(0,0,0,.25)'}}/>}
             autoComplete="off"
                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                     type="password"
                     placeholder="Şifre"/>
          </FormItem>
          <Link className="gx-login-form-forgot" to="/forget-password" style={{color:'#350000'}}>Şifremi Unuttum</Link>

          <div style={{marginTop:15,marginBottom:10}}>
            <form onSubmit={onSubmits} style={{marginTop:5,marginBottom:10}}>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6LfX1CIdAAAAAC9TS6J53DDfVYb4Xnn7gWJSWCdd"
                type={"image"}
                hl={"tr"}
                style={{marginLeft:20}}
                onChange={onChange}
              />
            </form>
          </div>

          <FormItem className="gx-text-center">
            <Button onClick={success} type="primary"  htmlType="submit"  onClick={() => setLoading(true)} loading={loading}>
              Giriş Yap
            </Button>
          </FormItem>
        </Form>
      </div>
      <Modal 
      visible={visible} onOk={form.submit} okButtonProps={{hidden:true}} cancelButtonProps={{hidden:true}} footer={null} onCancel={handleCancel}>
      <p style={{marginTop:10,textAlign:'center',fontSize:16}}> Lütfen telefonunuza gelen şifreyi <b>{seconds}</b> saniye içinde girin; </p>
     
      <Form
                   onFinish={handleSubmit}
                    >
                <Row style={{marginBottom: -25,marginLeft:32}}>
               
                <Col span={15}>
                <Form.Item
                name="Sms"
                >
                <Input 
                 onKeyPress={(e) => { (e.key === 'e' || e.key === "E") && e.preventDefault(); }}
                onChange={() => { setErrorText("")}} type='number'/>
                </Form.Item>  
                </Col>
                <Col span={6}>
                <Form.Item  >
                <Button type="primary" htmlType="submit" onClick={() => setLoadingBtn(true)} loading={loadingBtn}>
                    Onayla
                </Button>
                </Form.Item>
                </Col>
                <Col span={3}></Col>
                </Row>
              </Form>
              <p style={{color:'darkred',textAlign:'center',fontWeight:600}}>{errorText}</p>
      </Modal>
    </div>
  );
};

export default SignIn;
